const initLocationModal = (root = document) => {
  const dialog = root.querySelector('[data-location-modal]');
  if (!dialog || dialog.dataset.locationInit === 'true') return;
  dialog.dataset.locationInit = 'true';

  const open = () => {
    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', 'open');
    }
  };

  const close = () => {
    if (typeof dialog.close === 'function') {
      dialog.close();
    } else {
      dialog.removeAttribute('open');
    }
  };

  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) close();
  });

  dialog.querySelectorAll('[data-location-close]').forEach((button) => {
    button.addEventListener('click', (event) => {
      event.preventDefault();
      close();
    });
  });

  window.openLocationModal = open;
  window.closeLocationModal = close;
};

document.addEventListener('DOMContentLoaded', () => initLocationModal());
document.addEventListener('shopify:section:load', (event) => initLocationModal(event.target));
